import axios, { CancelToken, isCancel } from 'axios'
import { get, head, values } from 'lodash'
import humps from 'humps'
import { toast } from 'react-toastify'

import { getToken } from './auth'
import { BASE_URL, OIDC_ISSUER } from './env'

const stadiumApi = axios.create({
  transformRequest: [
    (data) => {
      if (data instanceof FormData) {
        return data
      }
      return humps.decamelizeKeys(get(data, 'data'))
    },
    ...axios.defaults.transformRequest,
  ],
  transformResponse: [
    ...axios.defaults.transformResponse,
    (data) =>
      humps.camelizeKeys(data, (key, convert) => {
        return /-/.test(key) ? key : convert(key)
      }),
  ],
  baseURL: BASE_URL,
})

stadiumApi.interceptors.request.use((config) => ({
  ...config,
  headers: {
    ...config.headers,
    authorization: `Bearer ${getToken()}`,
  },
}))

stadiumApi.interceptors.response.use(
  (response) => {
    if (['post', 'put', 'delete'].includes(response.config.method)) {
      toast.success('Success!')
    }
    return response
  },
  (error) => {
    if (!isCancel(error)) {
      // errorMessage is sometimes nested
      const errorMessage =
        get(
          head(head(values(error.response.data))),
          'errorMessage'
        ) || get(error, 'response.data.errorMessage')

      if (errorMessage) {
        toast.error(errorMessage)
        return undefined
      }

      toast.error('Something went wrong.')
    }

    return Promise.reject(error)
  }
)

const porticoApi = axios.create({
  transformRequest: [
    (data) => humps.decamelizeKeys(get(data, 'data')),
    ...axios.defaults.transformRequest,
  ],
  transformResponse: [
    ...axios.defaults.transformResponse,
    (data) =>
      humps.camelizeKeys(data, (key, convert) => {
        return /-/.test(key) ? key : convert(key)
      }),
  ],
  baseURL: OIDC_ISSUER,
})

porticoApi.interceptors.request.use((config) => ({
  ...config,
  headers: {
    ...config.headers,
    authorization: `Bearer ${getToken()}`,
  },
}))

porticoApi.interceptors.response.use(
  (response) => {
    if (['post', 'put', 'delete'].includes(response.config.method)) {
      toast.success('Success!')
    }
    return response
  },
  (error) => {
    if (!isCancel(error)) {
      // errorMessage is sometimes nested
      const errorMessage =
        get(
          head(head(values(error.response.data))),
          'errorMessage'
        ) || get(error, 'response.data.errorMessage')

      if (errorMessage) {
        toast.error(errorMessage)
        return undefined
      }

      toast.error('Something went wrong.')
    }

    return Promise.reject(error)
  }
)

export const getCanceller = () => CancelToken.source()

export { stadiumApi, porticoApi }
